import script from "./AuraHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AuraHeader.vue?vue&type=style&index=0&id=5e9c6d4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e9c6d4e"]])

export default __exports__